<template>
  <DashboardCard :border="false" :title="$t('widgets.rim.title')" :firstContent="true">
    <template v-slot:content>
      <div
          style="width: 200px; height: 200px;"
          class="p-2 mx-auto border rounded-circle shadow-circle mb-2"
      >
        <Doughnut :chart-data="chartData" :chart-options="chartOptions" :plugins="[centerTextPlugin]" />
      </div>
    </template>

    <template v-slot:table>
      <MDBTable borderless class="table-dashboard mx-auto p-0">
        <tbody>
          <tr
              v-for="(label, i) in labels"
              :key="i"
              class="border fs-12px"
          >
            <td>
                <span
                    class="legend-circle"
                    :style="{ backgroundColor: colors[i] }"
                ></span>
              {{ label }}
            </td>
            <td>{{ percentages[i] }}</td>
          </tr>
        </tbody>
      </MDBTable>
    </template>
  </DashboardCard>
</template>

<script setup>
import {computed, defineProps} from 'vue';
import DashboardCard from "../User/Wholesaler/DashboardCard.vue";
import { MDBTable } from "mdb-vue-ui-kit";
import { Doughnut } from "vue-chartjs";
import {
  Chart as ChartJS,
  Title,
  Tooltip,
  Legend,
  ArcElement,
} from "chart.js";
import {createCenterTextPlugin} from "../../utils/chartPlugins";
import {useI18n} from "vue-i18n";

ChartJS.register(Title, Tooltip, Legend, ArcElement);

const props = defineProps({
  data: { type: Object, required: true },
});

const { t } = useI18n();

const labels = ["< 15”", "16”", "17”", "18”", "> 19”"];
const colors = ["#FF0230", "#1972C3", "#CBB4A3", "#2D9567", "#58595B"];

const percentages = computed(() => [
  props.data.inch_15_or_less_percent,
  props.data.inch_16_percent,
  props.data.inch_17_percent,
  props.data.inch_18_percent,
  props.data.inch_19_or_more_percent,
])

const chartData = {
  labels,
  datasets: [
    {
      data: [
        props.data.inch_15_or_less,
        props.data.inch_16,
        props.data.inch_17,
        props.data.inch_18,
        props.data.inch_19_or_more,
      ],
      backgroundColor: colors,
      borderColor: "#fff",
      borderWidth: 2,
      spacing: 3,
    },
  ],
};

const chartOptions = {
  responsive: true,
  cutout: "70%",
  plugins: {
    legend: { display: false },
    tooltip: {
      enabled: true,
      callbacks: {
        label: function (ctx) {
          const value = ctx.raw;
          return ` ${ctx.label}: ${value} (${percentages.value[ctx.dataIndex]}%)`;
        },
      },
    }
  },
};

const centerTextPlugin = createCenterTextPlugin(t('widgets.rim.centerTitle'),{
  color: "#000",
  weight: "700",
  divisor: 15,
});
</script>

<style scoped lang="scss">
@import "@/styles/_variables.scss";
@import "@/styles/table_dashboard.scss";
</style>
